import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  ErrorCode,
  IAppErrorFactory,
  IErrorTrackingService,
  IJobBase,
  IJobsService,
  IUpdateJobUseCase,
  IUseCaseOutputFactory,
  UpdateJobUseCaseInput,
  UpdateJobUseCaseOutput,
} from '../../types'

@injectable()
export default class UpdateJobInteractor implements IUpdateJobUseCase {
  @inject(symbols.IJobsService) private jobsService: IJobsService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  @inject(symbols.IErrorTrackingService) private errorTrackingService: IErrorTrackingService

  @inject(symbols.IUseCaseOutputFactory) private outputFactory: IUseCaseOutputFactory<{
    job: null | IJobBase
  }>

  async handle(input: UpdateJobUseCaseInput): Promise<UpdateJobUseCaseOutput> {
    const output = this.outputFactory.create({
      defaultValue: {
        job: null,
      },
    })
    try {
      output.data.job = await this.jobsService.updateJob(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    if (output.error?.code === ErrorCode.NO_SUBSCRIPTION_ERROR) {
      try {
        // サブスク契約してなくて弾かれた場合、更新後の求人のデータを取得
        output.data.job = await this.jobsService.fetchJob({
          slug: input.job.slug,
        })
      } catch (e) {
        // NO_SUBSCRIPTION_ERROR を上書きしないように、インスタンスだけ作成してエラーレポートだけ飛ばす
        this.errorFactory.create({
          originalInstance: e as Error,
        })
      }
    }

    return output
  }
}
